module.exports = __webpack_public_path__ + "img/logo.3ef96975.png";